import Header from './page/header';
import Footer from './page/footer';
import ajax from './ajax/ajax';
import Fixed from './plugins/fixed';


Header();
Footer();
Fixed();
ajax();



// WEBPACK FOOTER //
// ./js/com.js